export default "/images/icons8-israel.png?687160eec3f67229eb5a434a36da58d8";